import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { MarketBaseSettingsState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/marketsSettings/components/marketBaseSettings/MarketBaseSettings.state';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';



export interface MarketBaseSettingsPropsType {
    marketId: MarketId;
}

export const MarketBaseSettings = observer('MarketBaseSettings', (propsIn: MarketBaseSettingsPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const marketModel = props.marketId.getModel();
    const [state] = useState(() => new MarketBaseSettingsState(appState, props));

    if (marketModel === null) {
        return null;
    }

    return (<>
        <div className='col-6'>
            {
                marketModel.getSpApplicable || marketModel.sp ?
                    <div className='element checkbox' data-test='starting-price-checkbox'>
                        <label>
                            <input type='checkbox' defaultChecked={marketModel.sp} onChange={state.onChangeStartingPrice}/>
                            <span>Starting price</span>
                        </label>
                    </div> : null
            }

            {
                marketModel.getSpApplicable || marketModel.spOnly ?
                    <div className='element checkbox' data-test='starting-price-only-checkbox'>
                        <label>
                            <input type='checkbox' defaultChecked={marketModel.spOnly} onChange={state.onChangeStartingPriceOnly}/>
                            <span>Starting price only</span>
                        </label>
                    </div> : null
            }

            {
                marketModel.getBpApplicable || marketModel.bp ?
                    <div className='element checkbox' data-test='best-odds-guaranteed-checkbox'>
                        <label>
                            <input type='checkbox' defaultChecked={marketModel.bp} onChange={state.onChangeBestOdds}/>
                            <span>Best Odds Guaranteed</span>
                        </label>
                    </div> : null
            }

            {
                marketModel.getBlockSettlement !== null ?
                    <div className='element checkbox' data-test='block-settlement-checkbox'>
                        <label>
                            <input type='checkbox' defaultChecked={marketModel.getBlockSettlement} onChange={state.onChangeBlockSettlement}/>
                            <span>Block settlement</span>
                        </label>
                    </div> : null
            }

            {
                marketModel.getBetReferralEnabled !== null ?
                    <div className='element checkbox' data-test='bet-referral-enabled-checkbox'>
                        <label>
                            <input type='checkbox' defaultChecked={marketModel.getBetReferralEnabled} onChange={state.onChangeBetReferral}/>
                            <span>Bet referral enabled</span>
                        </label>
                    </div> : null
            }

            <div className='element checkbox' data-test='singles-only-checkbox'>
                <label>
                    <input type='checkbox' defaultChecked={marketModel.singlesOnly} onChange={state.onChangeSinglesOnly}/>
                    <span>Singles only</span>
                </label>
            </div>

        </div>
        <div className='col-6'>
            <div className='element checkbox' data-test='in-play-checkbox'>
                <label>
                    <input type='checkbox' defaultChecked={marketModel.tradedInPlay} onChange={state.onChangeTraderInPlay}/>
                    <span>In play</span>
                </label>
            </div>


            <div className={`element hasLabel ${state.inPlayError !== null ? 'invalid error' : ''}`} data-test='in-play-delay'>
                <input
                    type='text'
                    name='inPlayDelay'
                    value={state.getInPlayDelay}
                    onChange={state.onChangeInPlayDelay}
                    onBlur={state.onSaveInPlayDelay}
                />
                <label>Bet delay (in seconds)</label>
                {
                    state.inPlayError !== null ?
                        <div className='error-message'>
                            <div className='error-message-content'>{state.inPlayError}</div>
                        </div> : null
                }
            </div>

            <div className={`element hasLabel ${state.eachWayStakeReductionError !== null ? 'invalid error' : ''}`} data-test='each-way-stake-reduction'>
                <input
                    type='text'
                    name='inPlayDelay'
                    value={state.getEachWayStakeReduction}
                    onChange={state.onChangeEachWayStake}
                    onBlur={state.onSaveEachWayStake}
                />
                <label>Each way stake reduction %</label>
                {
                    state.eachWayStakeReductionError !== null ?
                        <div className='error-message'>
                            <div className='error-message-content'>{state.eachWayStakeReductionError}</div>
                        </div> : null
                }
            </div>
        </div>
    </>);
});
